/**
 * @generated SignedSource<<6fb819c6e5b62318d03d752e77d3218a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { UsernameOrID } from "@/common/relayCustomScalar";
export type UpdateDatasetVersionInput = {
  authors?: ReadonlyArray<DatasetVersionAuthorInput> | null | undefined;
  description?: string | null | undefined;
  license?: string | null | undefined;
  version?: Semver | null | undefined;
};
export type DatasetVersionAuthorInput = {
  registered: UsernameOrID;
  unregistered?: never;
} | {
  registered?: never;
  unregistered: UnregisteredDatasetVersionAuthorInput;
};
export type UnregisteredDatasetVersionAuthorInput = {
  fullName: string;
};
export type DatasetVersionUpdateMutation$variables = {
  id: string;
  input: UpdateDatasetVersionInput;
};
export type DatasetVersionUpdateMutation$data = {
  readonly updateDatasetVersion: {
    readonly description: string;
    readonly id: string;
  };
};
export type DatasetVersionUpdateMutation = {
  response: DatasetVersionUpdateMutation$data;
  variables: DatasetVersionUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "datasetVersionId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DatasetVersion",
    "kind": "LinkedField",
    "name": "updateDatasetVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetVersionUpdateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DatasetVersionUpdateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "f46c4186f4c95e8de686896dd99c2f76",
    "id": null,
    "metadata": {},
    "name": "DatasetVersionUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation DatasetVersionUpdateMutation(\n  $id: ID!\n  $input: UpdateDatasetVersionInput!\n) {\n  updateDatasetVersion(datasetVersionId: $id, input: $input) {\n    id\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "1382a481e045b0b001f06b0de8f6ba21";

export default node;
